import { Task } from "../../../queries/tasks/use-tasks";
import { useSendPackagingPrinterData } from "@/queries/tasks/use-send-packaging-printer-data";
import { useCallback } from "react";
import { MarkingTaskShared } from "./marking-task-shared";
import { useTaskParameter } from "@/queries/tasks/use-task-parameter";

export function PackagingPrinting({ task }: { task?: Task }) {
  const { sendPackagingPrinterData, isPending, isSuccess, error } =
    useSendPackagingPrinterData();

  const { taskParameter } = useTaskParameter({
    parameter: "GF_AutomaticallyPrintPackagingLabel",
    taskId: task?.Id,
  });

  const autoMark = taskParameter?.toLowerCase() === "true";

  const print = useCallback(() => {
    if (!task?.Id) return;

    sendPackagingPrinterData(task.Id);
  }, [sendPackagingPrinterData, task?.Id]);

  if (!task) return null;

  return (
    <MarkingTaskShared
      task={task}
      autoMark={autoMark}
      startedManually={isSuccess}
      isPending={isPending}
      onMark={print}
      error={error}
    />
  );
}
